import config from "./config.js";
const siteConfig = config[process.env.NODE_ENV];
export default function vconsole() {
  if (siteConfig.host == "stage.journal.ren") {
    return import(/* webpackChunkName: "dev" */ "vconsole");
  }
}
